import Auth from './auth';
import * as constants from "./Constants";
import { StringUtils } from './StringUtils';
//import { getImpersonatedUserId, getSpartanImpersonatedUserId } from "../api/apiUtils";

export function toCurrencyString(value, locale = "en-US", minimumFractionDigits = 2, maximumFractionDigits = 2) {
    let currency = "USD";
    let culture = locale;

    if (locale.indexOf("en") !== -1) {
        culture = "en-US";
    }
    else {
        const auth = new Auth();
        const globalCurrency = getCurrency(auth, constants.GlobalSettingsStorageKey);

        if (globalCurrency && globalCurrency.defaultCurrency && globalCurrency.defaultCurrency.code) {
            currency = globalCurrency.defaultCurrency.code;
        }
    }

    try {
        const formatter = new Intl.NumberFormat(culture, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits,
        });

        return formatter.format(Number(value));
    }
    catch {
        let currency = "USD";
        let culture = "en-US";

        const formatter = new Intl.NumberFormat(culture, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits,
        });

        return formatter.format(Number(value));
    }
}

export function toLocaleNumberString(value, locales = "en-CA", minimumFractionDigits = 2, maximumFractionDigits = 2) {

    const n = Number(value);
    const strValue = n.toLocaleString(locales, { minimumFractionDigits, maximumFractionDigits });

    return strValue;
}

export function getCurrency(auth, globalSettingsStorageKey) {
    const globalSettingValue = auth.getItemFromCookies(globalSettingsStorageKey) || null;

    if (globalSettingValue && globalSettingValue.currencies && globalSettingValue.currencies.length > 0) {
        const defaultCurrency = globalSettingValue.currencies.find(c => c.isDefault);
        return {
            currencies: globalSettingValue.currencies,
            defaultCurrency
        }
    }

    return null;
}

export function getFormatedFileSizeString(fileSize, decimals) {
    if (fileSize && fileSize > 0) {
        const k = 1024
        const dm = !decimals ? 2 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(fileSize) / Math.log(k))

        if (i > 1) {
            return `${parseFloat((fileSize / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        } else {
            return `${Math.ceil((fileSize / Math.pow(k, i)))} ${sizes[i]}`
        }
        
    }
    else {
        return "";
    }
}

export function getDropdownElementText(elementFullName, elementValue, fieldDefinitions) {
    let selectedText = null;
    let found = false;

    for (let i = 0; i < fieldDefinitions.length; i++) {        
        const fieldDefinition = fieldDefinitions[i];
        for (let j = 0; j < fieldDefinition.layouts.length; j++) {
            const l = fieldDefinition.layouts[j];
            for (let k = 0; k < l.fieldDefinitions.length; k++) {
                const d = l.fieldDefinitions[k];
                const formatedName = fieldDefinition.name + d.name.charAt(0).toUpperCase() + d.name.slice(1);
                if (d.dataType === 'list' && formatedName === elementFullName) {
                    const lookupItem = d.lookupItems.find(item => item.value === elementValue);
                    selectedText = lookupItem ? lookupItem.text : null;

                    found = true;
                    break;
                }
            }
            if (found) break;
        }
        if (found) break;
    }

    return selectedText;
}

export function isValidDeliveryTerms(value) {
    return value === 'Collect'
        || value === 'Prepaid & Add'
        || value === 'Third Party';
}

export function isValidShipVia(value) {
    return value === 'Best Way Air'
        || value === 'Best Way Ground';
}

export function isValidCountryCode(value) {
    return !StringUtils.isEmpty(value) 
    && (value.toUpperCase() === "US"
        || value.toUpperCase() === "CA");
}
